import React from 'react';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import Tooltip from 'libraries/Tooltip';
import ReapplyIcon from 'img/reapply.svg';

const useStyles = makeStyles(theme => ({
    reapplyLabel: {
        marginLeft: 10
    }
}));

const ReapplyLabel = () => {
    const { reapplyLabel } = useStyles();

    return (
        <Tooltip label="Reinvited" className={reapplyLabel}>
            <img src={ReapplyIcon} alt="+" />
        </Tooltip>
    );
};

export default ReapplyLabel;
